import { defaultTo, map, orderBy } from "lodash";
import {
    IModel,
    Model,
    ModelRecord,
    SalesItemAttributeTypeModel,
    SalesItemAttributeProcessingTypeModel,
    SalesItemAttributeListValueModel,
    BusinessLineModel
} from "@common/models";

export interface ISalesItemAttributeModel extends IModel {
    salesItemAttributeId: number;
    salesItemId: number;
    salesItemAttributeTypeId: number
    salesItemAttributeProcessingTypeId: number;
    name: string;
    allowMultiple?: boolean | undefined;
    isReadOnly?: boolean | undefined;
    defaultValue: string;
    sortOrder: number;
    relatedEntityId?: number | undefined;
    validationFormat: string;
    salesItemAttributeType: SalesItemAttributeTypeModel;
    salesItemAttributeProcessingType: SalesItemAttributeProcessingTypeModel;
    salesItemAttributeListValues: SalesItemAttributeListValueModel[];
    businessLine: BusinessLineModel | undefined;
    businessLineId: number | undefined;
}

export class SalesItemAttributeModel extends Model implements ModelRecord<ISalesItemAttributeModel> {
    salesItemAttributeId: number;
    salesItemId: number;
    salesItemAttributeTypeId: number
    salesItemAttributeProcessingTypeId: number;
    name: string;
    allowMultiple: boolean;
    isReadOnly: boolean;
    defaultValue: string;
    sortOrder: number;
    relatedEntityId: number | undefined;
    validationFormat: string;
    salesItemAttributeType: SalesItemAttributeTypeModel;
    salesItemAttributeProcessingType: SalesItemAttributeProcessingTypeModel;
    salesItemAttributeListValues: SalesItemAttributeListValueModel[] = [];
    businessLine: BusinessLineModel | undefined;
    businessLineId: number | undefined;


    constructor(params?: Partial<ISalesItemAttributeModel>) {
        super(params);
        this.salesItemAttributeId = defaultTo(params?.salesItemAttributeId, 0);
        this.salesItemId = defaultTo(params?.salesItemId, 0);
        this.salesItemAttributeTypeId = defaultTo(params?.salesItemAttributeTypeId, 0);
        this.salesItemAttributeProcessingTypeId = defaultTo(params?.salesItemAttributeProcessingTypeId, 0);
        this.name = defaultTo(params?.name, '');
        this.allowMultiple = defaultTo(params?.allowMultiple, false);
        this.isReadOnly = defaultTo(params?.isReadOnly, false);
        this.defaultValue = defaultTo(params?.defaultValue, '');
        this.sortOrder = defaultTo(params?.sortOrder, 0);
        this.relatedEntityId = defaultTo(params?.relatedEntityId, undefined);
        this.validationFormat = defaultTo(params?.validationFormat, '');
        this.salesItemAttributeType = params?.salesItemAttributeType ? new SalesItemAttributeTypeModel(params.salesItemAttributeType) : new SalesItemAttributeTypeModel();
        this.salesItemAttributeProcessingType = params?.salesItemAttributeProcessingType ? new SalesItemAttributeProcessingTypeModel(params.salesItemAttributeProcessingType) : new SalesItemAttributeProcessingTypeModel();
        map(orderBy(params?.salesItemAttributeListValues, v => v.sortOrder), (alv) => {
            this.salesItemAttributeListValues.push(new SalesItemAttributeListValueModel(alv))
        });
        this.businessLine = defaultTo(params?.businessLine, undefined);
        this.businessLineId = defaultTo(params?.businessLineId, undefined);
    }
}
